import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../Context/auth';
import MenuLateral from '../Components/MenuPrincipal/MenuLateral';
import MarcaForm from '../Components/MarcaForm/MarcaForm';
import './Marcas.css';
import Swal from 'sweetalert2';

function NovaMarca() {
    const { currentUser, appUserData } = useAuth();
    const navigate = useNavigate();

    // Verifica permissão de cadastro
    React.useEffect(() => {
        if (appUserData && !appUserData['cadastrar_marcas']) {
            Swal.fire({
                icon: 'error',
                title: 'Acesso Negado',
                text: 'Você não tem permissão para cadastrar marcas.',
                confirmButtonColor: '#2185c6'
            }).then(() => {
                navigate('/app/home');
            });
        }
    }, [appUserData, navigate]);
    const [loading, setLoading] = useState(false);
    const [mensagem, setMensagem] = useState('');

    const handleCadastrar = async (dados) => {
        setMensagem('');
        setLoading(true);

        try {
            const token = await currentUser.getIdToken();
            const API_URL = process.env.REACT_APP_API_URL;
            const response = await fetch(`${API_URL}/api/marcas`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({ descricao: dados.descricao.trim() })
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || "Falha ao salvar a marca.");
            }

            navigate('/app/marcas');
        } catch (error) {
            console.error("Erro ao adicionar marca: ", error);
            setMensagem(error.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="marcas-page-container" style={{ display: 'flex', paddingTop: 0 }}>
            <MenuLateral />
            <div className="content-with-sidebar">
                <div className="marcas-header">
                    <div className="d-flex align-items-center gap-3">
                        <button className="btn btn-link text-secondary p-0" onClick={() => navigate('/app/marcas')} title="Voltar">
                            <i className="fas fa-arrow-left fa-lg"></i>
                        </button>
                        <h1 className="marcas-title m-0">
                            Nova <span className="highlight">Marca</span>
                        </h1>
                    </div>
                </div>

                <main className="marcas-content">
                    {mensagem && (
                        <div className="alert alert-danger d-flex align-items-center mb-4" role="alert">
                            <i className="fas fa-exclamation-circle me-2"></i>
                            <div>{mensagem}</div>
                        </div>
                    )}

                    <MarcaForm
                        onSubmit={handleCadastrar}
                        loading={loading}
                    />
                </main>
            </div>
        </div>
    );
}

export default NovaMarca;